import React from "react";
import { Modal, Button } from "antd";
import { CloseCircleOutlined } from "@ant-design/icons";
import styled from "styled-components";

const StyledModal = styled(Modal)`
	.ant-modal-content {
		background: #f3f5ff !important;
		border-radius: 24px !important;
		padding: 32px !important;
		box-shadow: 0px 12px 24px 0px #1559a53d !important;
	}
`;

const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
`;

const Title = styled.div`
	font-size: 24px;
	font-weight: 600;
	color: #1a1a1a;
`;

const Description = styled.div`
	font-size: 16px;
	color: #595959;
`;

const ButtonContainer = styled.div`
	display: flex;
	gap: 12px;
	margin-top: 12px;
`;

const DiscardButton = styled(Button)`
	flex: 1;
	height: 48px;
	border-radius: 24px;
	border: 2px solid #3a0ca3;
	color: #3a0ca3;
	font-weight: 600;

	&:hover,
	&:focus-visible {
		box-shadow: inset 0 0 0 2px #3a0ca3 !important;
		border-color: #3a0ca3 !important;
		color: #3a0ca3 !important;
	}
`;

const BackButton = styled(Button)`
	flex: 1;
	height: 48px;
	border-radius: 24px;
	background: #3a0ca3 !important;
	color: #fff !important;
	font-weight: 600;
	border: none;

	&:hover {
		background: #3a0ca3 !important;
		opacity: 0.9;
	}
`;

interface DiscardChangesConfirmModalProps {
	open: boolean;
	onDiscard: () => void;
	onBack: () => void;
}

export const DiscardChangesConfirmModal: React.FC<DiscardChangesConfirmModalProps> = ({ open, onDiscard, onBack }) => {
	return (
		<StyledModal title={null} open={open} onCancel={onBack} footer={null} closable={false} centered width={420}>
			<Container>
				<CloseCircleOutlined style={{ fontSize: 28, color: "#1a1a1a" }} />
				<Title>Discard Changes</Title>
				<Description>All changes will be discarded.</Description>
				<ButtonContainer>
					<DiscardButton onClick={onDiscard}>Discard and Close</DiscardButton>
					<BackButton type="primary" onClick={onBack}>
						Back
					</BackButton>
				</ButtonContainer>
			</Container>
		</StyledModal>
	);
};
